import React, { SyntheticEvent, useState } from "react";
import { AutocompleteChangeReason } from "@mui/material/Autocomplete";
import queryString from "query-string";

import { setItemInLocalStorage, getItemFromLocalStorage } from "../../../../../config/localStorage";


import SelectOption from "../../../../../domains/SelectOptions";

type FilterContext = {
  getFilter: () => string
}

const FilterContext = React.createContext<FilterContext>(null);

interface Props {
  children: React.ReactNode
}

export function FilterContextProvider({ children }: Props) {

  // const buildFilterParams = () => {
  //   const filter = {
  //     status,
  //     category,
  //     userId: userValue,
  //     searchBy: { searchValue, searchByValue },
  //   };

  //   const params = Object.keys(filter).reduce((acc: any, current) => {
  //     if (filter[current]) {
  //       if (current === "category") {
  //         acc = {
  //           ...acc,
  //           "filter[category]": filter[current],
  //         };
  //       }

  //       if (current === "status") {
  //         acc = {
  //           ...acc,
  //           "filter[status]": filter[current],
  //         };
  //       }

  //       if (current === "userId" && filter[current].value !== "") {
  //         acc = {
  //           ...acc,
  //           "filter[userId]": filter[current].value,
  //         };
  //       }

  //       if (current === "searchBy" && filter[current].searchValue !== "") {
  //         let key = filter[current]?.searchByValue;
  //         let value = filter[current]?.searchValue;
  //         if (key === "port") {
  //           key = "portId";
  //           value = filter[current]?.searchValue.value;
  //         }
  //         if (key === "systemId") {
  //           value = filter[current]?.searchValue.value;
  //         }
  //         acc = {
  //           ...acc,
  //           [`filter[${key}]`]: value,
  //         };
  //       }
  //     }

  //     return acc;
  //   }, {});
    
  //   const stringified = queryString.stringify(params);
  //   setItemInLocalStorage("filterSearch", stringified);
  // };

  const getFilter = () => {
    return getItemFromLocalStorage("filterSearch", "");
  };

  return (
    <FilterContext.Provider
      value={{
        // buildFilterParams,
        getFilter
      }}
    >
      {children}
    </FilterContext.Provider>
  );
}

export function useFilterContext() {
  const context = React.useContext(FilterContext);

  if (context === undefined) {
    throw new Error("useFilterContext must be used within a DropZoneProvider");
  }

  return context;
}
